import { assignParent } from '../creators/common';
/**
 * Set the direction of this order by field to the provided value.
 *
 * @param orderDirection Direction to set for the order by clause
 */
export function setOrderDirection(orderDirection) {
  this.direction = orderDirection;
  assignParent(this);
}

/**
 * Replace the current orderBy field with the provided field in `orderByField`.
 *
 * @param orderByField field to set as the new value
 */
export function replace(orderByField) {
  if (this.parent) {
    this.parent.replaceOrderField(this, orderByField);
  }
}

/**
 * Remove the current orderBy field from the orderBy node.
 * The parent node is responsible for implementing the logic to remove any
 * references to the child node.
 *
 */
export function remove() {
  if (this.parent) {
    this.parent.removeOrderField(this);
  }
}